import { defineMessages } from '@edx/frontend-platform/i18n';
const messages = defineMessages({
  fieldLabel: {
    id: 'registration.form.full.name.label',
    defaultMessage: '{label}',
    description: 'Label for input field'
  }
});
export default messages;
//# sourceMappingURL=messages.js.map